<template>
  <modal
    ref="invoiceDataModal"
    template="neutral"
    ref-name="invoiceDataModal"
    class="invoice-modal"
    :close-button-enabled="true"
  >
    <div
      class="invoice-modal__wrapper"
      :class="{ 'invoice-modal__wrapper--loading': loading }"
    >
      <spinner
        v-if="loading"
        class="loading"
      />
      <template v-else>
        <div v-if="noteData">
          <h2>Dados da Nota fiscal:</h2>
          <div class="invoice-modal__content">
            <ul>
              <li>
                <strong> Tomador: </strong>
                {{ noteData.taker }}
                <ButtonCopy
                  v-if="noteData.taker"
                  :text-to-copy="noteData.taker"
                />
              </li>
              <li>
                <strong> CNPJ tomador: </strong>
                {{ noteData.takerCNPJ }}
                <ButtonCopy
                  v-if="noteData.takerCNPJ"
                  :text-to-copy="noteData.takerCNPJ"
                />
              </li>
              <li>
                <strong> Prestador: </strong>
                {{ noteData.provider }}
                <ButtonCopy
                  v-if="noteData.provider"
                  :text-to-copy="noteData.provider"
                />
              </li>
              <li>
                <strong> CNPJ Prestador: </strong>
                {{ noteData.providerCNPJ }}
                <ButtonCopy
                  v-if="noteData.providerCNPJ"
                  :text-to-copy="noteData.providerCNPJ"
                />
              </li>
              <li>
                <strong> I.M. Prestador: </strong>
                {{ noteData.providerIM }}
                <ButtonCopy
                  v-if="noteData.providerIM"
                  :text-to-copy="noteData.providerIM"
                />
              </li>
              <li>
                <strong> Nota Fiscal: </strong>
                {{ noteData.noteNumber }}
                <ButtonCopy
                  v-if="noteData.noteNumber"
                  :text-to-copy="noteData.noteNumber"
                />
              </li>
              <li>
                <strong> Valor: </strong>
                {{ noteData.value }}
                <ButtonCopy
                  v-if="noteData.value"
                  :text-to-copy="noteData.value"
                />
              </li>
              <li>
                <strong> Código de Verificação (Identificação): </strong>
                {{ noteData.verificationCode }}
                <ButtonCopy
                  v-if="noteData.verificationCode"
                  :text-to-copy="noteData.verificationCode"
                />
              </li>
              <li>
                <strong> Número do RPS: </strong>
                {{ noteData.rpsNumber }}
                <ButtonCopy
                  v-if="noteData.rpsNumber"
                  :text-to-copy="noteData.rpsNumber"
                />
              </li>
              <li>
                <strong> Código de Autenticidade: </strong>
                {{ noteData.authenticityCode }}
                <ButtonCopy
                  v-if="noteData.authenticityCode"
                  :text-to-copy="noteData.authenticityCode"
                />
              </li>
            </ul>
          </div>
          <div class="invoice-modal__actions">
            <button
              class="btn btn-primary btn-new"
              @click="goToNoteURL"
            >
              Ir para a prefeitura
            </button>
          </div>
        </div>
      </template>
    </div>
  </modal>
</template>

<script>
import billings from '@/api/billings'
import Spinner from '@/components/common/Spinner'
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'
import notify from '@/api/notification'

export default {
  name: 'InvoiceModal',
  components: {
    Spinner,
    ButtonCopy
  },
  data() {
    return {
      loading: false,
      noteData: null
    }
  },
  methods: {
    openInvoiceDataModal(noteData) {
      this.$refs.invoiceDataModal.open()
      this.getNoteData(noteData)
    },
    goToNoteURL() {
      window.open(this.noteData.cityHallAddress, '_blank', 'width=600, height=500')
    },
    getNoteData(noteData) {
      this.loading = true

      billings
        .getNoteData(noteData)
        .then(res => {
          this.loading = false
          this.noteData = res.data
        })
        .catch(err => {
          this.loading = false
          this.noteData = null
          this.$refs.invoiceDataModal.close()
          notify({
            title: 'AVISO: ',
            message: 'Não foi possível carregar os dados da Nota Fiscal.'
          })
          console.error(err)
        })
    }
  }
}
</script>

<style lang="scss">
  .invoice-modal {
    .md-dialog {
      width: 90%;
      min-height: 275px !important;
      padding: 30px 50px;
      max-height: 84% !important;

      &-content,
      &-title {
        padding: 0;

        .close-button {
          z-index: 2;
        }
      }

      .standard-modal__title {
        display: none;
      }
    }

    &__wrapper {
      font-family: 'Exo 2', sans-serif !important;
      min-height: 240px;

      &--loading {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &__content {
      padding: 20px 24px;
      background: rgba(22, 22, 22, 0.04);
      border-radius: 6px;
      margin-top: 18px;
      font-weight: 400;
      font-size: 14px;
      font-family: 'Exo 2', sans-serif !important;

      span {
        font-weight: 500;
        font-size: 16px;
        color: #4a4a4a;
      }

      ul {
        li {
          display: flex;
          align-items: center;

          &:hover {
            .btn-copy {
              opacity: 1;
            }
          }

          strong {
            margin-right: 8px;
          }

          .btn-copy {
            margin-left: 14px;

            span {
              color: #fff;
            }
          }
        }
      }
    }

    &__actions {
      display: flex;
      justify-content: center;
      margin-top: 24px;

      .btn {
        width: 100%;
        text-transform: uppercase;
        font-family: 'Exo 2', sans-serif !important;
      }
    }
  }
</style>
